export default __webpack_public_path__ + "static/media/banner-localizador.747a5b20.png";